export default __webpack_public_path__ + "static/NotoSans-ExtraBoldItalic-bc520f2095f1b2494aba4fb15dce7ad7.ttf";